// Put-away step-1 spot picker — selection behaviour only. The segmented control and the Platz-Nr.
// filter now live in the shared spot-picker_compiler.js ([data-spot-picker]); the put-away step-1
// root carries both [data-spot-picker] and [data-put-away-spot].
//
// `up` is a global in this app — do not import it.

up.compiler('[data-put-away-spot]', (root) => {
  const cta = root.querySelector('#put-away-cta')
  const baseUrl = cta?.dataset.materialUrl

  // Regal active state (the grid loads via Unpoly up-target)
  up.on(root, 'click', '.regal-btn', (event, link) => {
    root.querySelectorAll('.regal-btn').forEach((b) => b.classList.toggle('is-active', b === link))
  })

  const selectSpot = (btn, override) => {
    root.querySelectorAll('.platz-btn').forEach((b) => b.classList.toggle('is-selected', b === btn))
    const sel = root.querySelector('#spot-selection')
    const taken = btn.dataset.taken === 'true'
    sel.classList.add('is-selected')
    sel.innerHTML = renderSelection(btn, taken)
    if (cta && baseUrl) {
      const params = new URLSearchParams({ storage_spot_id: btn.dataset.spotId })
      if (override) params.set('override', '1')
      cta.setAttribute('href', `${baseUrl}&${params.toString()}`)
      cta.classList.remove('disabled')
    }
  }

  const renderSelection = (btn, taken) => {
    const label = taken ? 'Belegt – wird überschrieben' : 'Gewählter Lagerplatz'
    const cls = taken ? 'put-away-spot__selected--warn' : 'put-away-spot__selected--ok'
    const current = taken && btn.dataset.materialLabel ? ` · belegt mit ${btn.dataset.materialLabel}` : ''
    return `<div class="put-away-spot__selected ${cls}">
      <span class="put-away-spot__selected-label">${label}</span>
      <span class="put-away-spot__selected-value">${btn.dataset.spotName}${current}</span>
      <span class="put-away-spot__selected-code">${btn.dataset.spotCode}</span>
    </div>`
  }

  up.on(root, 'click', '.platz-btn', (event, btn) => {
    const taken = btn.dataset.taken === 'true'
    if (taken) {
      const ok = window.confirm(`Platz ${btn.dataset.spotName} ist belegt mit ${btn.dataset.materialLabel || 'Material'}. Material überschreiben?`)
      if (!ok) return
      selectSpot(btn, true)
    } else {
      selectSpot(btn, false)
    }
  })
})
